import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  AnalysesTypes,
  AnalysisResponse,
} from 'src/app/analyses/interfaces/analyses.types';

@UntilDestroy()
@Component({
  selector: 'app-analyses-list',
  templateUrl: './analyses-list.component.html',
  styleUrls: ['./analyses-list.component.scss'],
})
export class AnalysesListComponent implements OnChanges, OnInit {
  @Input() analyses$: Observable<AnalysisResponse[]>;
  @Input() data: AnalysisResponse[];
  @Input() type: AnalysesTypes;
  @Input() showNoResult = true;
  @Input() size = 10;
  @Input() reportCard = false;
  @Input() reCheckLabel = false;

  // pagination variables
  public analysesPaginated: AnalysisResponse[];
  public pageChanged$ = new BehaviorSubject(null);
  public page = 1;
  public pageCount: number;
  public collectionSize: number;

  ngOnInit(): void {
    combineLatest([
      this.pageChanged$,
      this.analyses$?.pipe(
        tap((analyses) => this.setPaginationVariables(analyses.length))
      ),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ([_, analyses]) =>
          (this.analysesPaginated = analyses.slice(
            (this.page - 1) * this.size,
            Math.min((this.page - 1) * this.size + this.size, analyses.length)
          ))
      );
  }

  ngOnChanges(): void {
    this.page = 1;
    if (this.data) {
      this.analyses$ = of(this.data);
    }
  }

  private setPaginationVariables(analysesCount: number): void {
    this.pageCount = Math.ceil(analysesCount / this.size);
    this.collectionSize = analysesCount;
  }
}
